// src/pages/Login.jsx - Kyber Security Branded Login
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(username, password);
    
    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #6B3FA0 0%, #4A2B70 100%)',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 20px 60px rgba(74, 43, 112, 0.3)',
        width: '100%',
        maxWidth: '450px',
        overflow: 'hidden'
      }}>
        {/* Header Section */}
        <div style={{
          background: 'linear-gradient(135deg, #F3EEFA 0%, #ffffff 100%)',
          padding: '40px',
          textAlign: 'center',
          borderBottom: '3px solid #6B3FA0'
        }}>
          <img 
            src="/images/342px_x_216px-01.png" 
            alt="Kyber Security" 
            style={{ 
              height: '60px', 
              width: 'auto',
              marginBottom: '20px'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <h1 style={{ 
            margin: 0, 
            marginBottom: '8px',
            fontSize: '28px',
            color: '#4A2B70',
            fontWeight: '700'
          }}>
            Assessment Portal
          </h1>
          <p style={{ 
            margin: 0, 
            fontSize: '15px', 
            color: '#7E4DB3',
            fontWeight: '400'
          }}>
            Security Compliance Management
          </p>
        </div>

        {/* Form Section */}
        <div style={{ padding: '40px' }}>
          <h2 style={{
            margin: 0,
            marginBottom: '25px',
            fontSize: '22px',
            color: '#4A2B70',
            fontWeight: '600',
            textAlign: 'center'
          }}>
            Sign In
          </h2>

          {error && (
            <div style={{
              padding: '15px',
              marginBottom: '25px',
              backgroundColor: '#FEE',
              border: '1px solid #FCC',
              borderLeft: '4px solid #E74C3C',
              borderRadius: '6px',
              color: '#C00',
              fontSize: '14px'
            }}>
              <strong>Error:</strong> {error}
            </div>
          )}

          {/* Microsoft SSO Button */}
          <button
            type="button"
            onClick={() => { window.location.href = '/api/auth/entra-login'; }}
            style={{
              width: '100%',
              padding: '13px',
              backgroundColor: 'white',
              color: '#333',
              border: '2px solid #E5D5F5',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              marginBottom: '20px',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.borderColor = '#0078D4';
              e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0, 120, 212, 0.1)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.borderColor = '#E5D5F5';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21 21">
              <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
              <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
              <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
              <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
            </svg>
            Sign in with Microsoft
          </button>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '20px',
          }}>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#E5D5F5' }} />
            <span style={{ fontSize: '13px', color: '#9B7BB8', whiteSpace: 'nowrap' }}>
              or sign in with username
            </span>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#E5D5F5' }} />
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: '600',
                color: '#4A2B70',
                fontSize: '14px'
              }}>
                Username
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Enter your username"
                style={{
                  width: '100%',
                  padding: '12px 15px',
                  border: '2px solid #E5D5F5',
                  borderRadius: '8px',
                  fontSize: '15px',
                  transition: 'all 0.2s ease',
                  fontFamily: 'inherit'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#6B3FA0';
                  e.target.style.boxShadow = '0 0 0 3px rgba(107, 63, 160, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#E5D5F5';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <div style={{ marginBottom: '25px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: '600',
                color: '#4A2B70',
                fontSize: '14px'
              }}>
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your password"
                style={{
                  width: '100%',
                  padding: '12px 15px',
                  border: '2px solid #E5D5F5',
                  borderRadius: '8px',
                  fontSize: '15px',
                  transition: 'all 0.2s ease',
                  fontFamily: 'inherit'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#6B3FA0';
                  e.target.style.boxShadow = '0 0 0 3px rgba(107, 63, 160, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#E5D5F5';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            <div style={{ textAlign: 'right', marginBottom: '25px' }}>
              <Link 
                to="/forgot-password" 
                style={{
                  color: '#6B3FA0',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'color 0.2s ease'
                }}
                onMouseOver={(e) => e.target.style.color = '#5A2F8A'}
                onMouseOut={(e) => e.target.style.color = '#6B3FA0'}
              >
                Forgot Password?
              </Link>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '14px',
                backgroundColor: loading ? '#9B7BB8' : '#6B3FA0',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 4px 12px rgba(107, 63, 160, 0.3)'
              }}
              onMouseOver={(e) => {
                if (!loading) {
                  e.target.style.backgroundColor = '#5A2F8A';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 16px rgba(107, 63, 160, 0.4)';
                }
              }}
              onMouseOut={(e) => {
                if (!loading) {
                  e.target.style.backgroundColor = '#6B3FA0';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 12px rgba(107, 63, 160, 0.3)';
                }
              }}
            >
              {loading ? (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                  <span style={{
                    display: 'inline-block',
                    width: '16px',
                    height: '16px',
                    border: '2px solid white',
                    borderTopColor: 'transparent',
                    borderRadius: '50%',
                    animation: 'spin 0.6s linear infinite'
                  }}></span>
                  Signing in...
                </span>
              ) : (
                'Sign In'
              )}
            </button>
          </form>
        </div>

        {/* Footer Section */}
        <div style={{
          padding: '20px 40px',
          backgroundColor: '#F3EEFA',
          borderTop: '1px solid #E5D5F5',
          textAlign: 'center'
        }}>
          <p style={{ 
            margin: 0, 
            fontSize: '13px', 
            color: '#7E4DB3',
            lineHeight: '1.5'
          }}>
            Need help? Contact <a href="mailto:support@kybersecure.com" style={{ color: '#6B3FA0', fontWeight: '600' }}>support@kybersecure.com</a>
          </p>
          <p style={{ 
            margin: '10px 0 0 0', 
            fontSize: '12px', 
            color: '#9B7BB8'
          }}>
            © {new Date().getFullYear()} Kyber Security. All rights reserved.
          </p>
        </div>
      </div>

      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default Login;
